import { render, staticRenderFns } from "./setProAccount.vue?vue&type=template&id=10aa372e&scoped=true&"
import script from "./setProAccount.vue?vue&type=script&lang=js&"
export * from "./setProAccount.vue?vue&type=script&lang=js&"
import style0 from "./setProAccount.vue?vue&type=style&index=0&id=10aa372e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa372e",
  null
  
)

export default component.exports